"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var baseStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '32px',
  width: '36px',
  borderRadius: '6px',
  border: '3px solid transparent',
  cursor: 'pointer',
  outline: 'none',
  '&:disabled': {
    pointerEvents: 'none',
    opacity: '30%'
  }
};
var _default = {
  IconButton: function IconButton(_ref) {
    var theme = _ref.theme,
        _ref$props = _ref.props,
        kind = _ref$props.kind,
        compressed = _ref$props.compressed;
    return compressed ? _objectSpread(_objectSpread({}, baseStyles), {}, {
      background: '#b2bfbf',
      border: "3px solid ".concat(theme['$heading-color']),
      pointerEvents: 'none',
      '&:focus,&:hover': {
        background: '#b2bfbf'
      }
    }) : kind === 'compact' ? {
      width: 24,
      height: 24,
      borderRadius: 6,
      border: 'none',
      background: 'none',
      padding: 0,
      '&:focus,&:hover': {
        background: theme['$button-color']
      }
    } : _objectSpread(_objectSpread({}, baseStyles), {}, {
      background: theme['$button-color'],
      boxShadow: '0 1px 1px rgba(0, 0, 0, 0.14)',
      '&:focus,&:hover': {
        background: theme['$button-color']
      }
    });
  }
};
exports["default"] = _default;
//# sourceMappingURL=style.js.map